import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from 'UIKit/Grid';
import OlimpicTable from 'sama_global/components/OlimpicTable';
import { fetchActiveOlimpics } from '@/modules/Olimpic';

const Stats = ({ olimpic, loadParticipate }) => {
  const { tryouts } = olimpic?.participant || {};

  useEffect(() => loadParticipate(), []);

  const data = useMemo(
    () =>
      Object.keys(tryouts || {}).map(key => ({
        date: key,
        tryout: tryouts[key],
        max: tryouts[key].slice(0, 6).reduce((v, a) => v + a, 0),
      })),
    [tryouts]
  );

  return (
    <Box>
      <OlimpicTable title="PERSONAL_RATING" data={data} personal />
    </Box>
  );
};

Stats.propTypes = {
  olimpic: PropTypes.object.isRequired,
  loadParticipate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  olimpic: state.olimpic.sama,
  user: state.user,
});

const mapDispatch = dispatch => ({
  loadParticipate(id) {
    dispatch(fetchActiveOlimpics(id));
  },
});

export default connect(mapStateToProps, mapDispatch)(Stats);
